/* eslint-disable prefer-arrow/prefer-arrow-functions */
import React, { useState } from 'react';
import axios from 'axios';

function B2BSignupForm() {
  const [formData, setFormData] = useState({
    companyName: '',
    siret: '',
    email: '',
    phone: '',
    adresse: '',
    acceptPolicy: false,
  });
  // const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';
  const handleChange = (e) => {
    const { id, type, value, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [id]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.acceptPolicy) {
      alert('Vous devez accepter la politique de confidentialité.');

      return;
    }
    console.log('Formulaire soumis : ', formData);
    // ici tu peux faire un appel API (ex: axios.post(...))

    try {
      const res = await axios.post(`/api/b2b/signup`, formData);

      alert(res.data.message || 'Demande enregistrée !');
    } catch (err) {
      console.error(err);
      alert("Erreur d'envoi. Vérifiez la console.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="container mt-4">
      <img
        src="/assets/svg/logos/logo.svg"
        alt="KeplerLogo"
        width="45%"
        style={{ display: 'flex', margin: '0px auto' }}
      />
      <h2 className="text-secondary" style={{ fontSize: '28px', paddingTop: '50px' }}>
        Créer un compte professionnel
      </h2>
      <p style={{ fontSize: '16px' }}>
        Accédez à notre plateforme dédiée aux professionnels pour consulter le catalogue,
        <br />
        vérifier tarifs & disponibilités, effectuer vos réservations et télécharger vos
        <br />
        documents de voyage en toute simplicité.
        <br />
      </p>
      <div className="mb-3">
        <label htmlFor="companyName" className="form-label">
          Nom de l'entreprise
        </label>
        <input
          type="text"
          className="form-control"
          id="companyName"
          value={formData.companyName}
          onChange={handleChange}
          required
          placeholder="Ex : Agence Voyages Soleil"
        />
      </div>

      <div className="mb-3">
        <label htmlFor="siret" className="form-label">
          Numéro SIRET
        </label>
        <input
          type="text"
          className="form-control"
          id="siret"
          value={formData.siret}
          onChange={handleChange}
          required
          placeholder="Ex : 123 456 789 00012"
        />
      </div>

      <div className="mb-3">
        <label htmlFor="email" className="form-label">
          Email professionnel
        </label>
        <input
          type="email"
          className="form-control"
          id="email"
          value={formData.email}
          onChange={handleChange}
          required
          placeholder="Ex : contact@agencevoyage.fr"
        />
      </div>

      <div className="mb-3">
        <label htmlFor="phone" className="form-label">
          Téléphone
        </label>
        <input
          type="tel"
          className="form-control"
          id="phone"
          value={formData.phone}
          onChange={handleChange}
          placeholder="Ex : +33 1 23 45 67 89"
        />
      </div>

      <div className="mb-3">
        <label htmlFor="Adresse" className="form-label">
          Adresse
        </label>
        <input
          type="text"
          className="form-control"
          id="adresse"
          value={formData.adresse}
          onChange={handleChange}
          placeholder="Ex : 12 Rue des Lilas, 75000 Paris"
        />
      </div>

      <div className="form-check mb-3">
        <input
          className="form-check-input"
          type="checkbox"
          id="acceptPolicy"
          checked={formData.acceptPolicy}
          onChange={handleChange}
        />
        <label className="form-check-label" htmlFor="acceptPolicy">
          J'accepte la{' '}
          <a href="/politique-confidentialite" target="_blank" rel="noopener noreferrer">
            politique de confidentialité
          </a>
        </label>
      </div>

      <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
        Créer le compte
      </button>
    </form>
  );
}

export default B2BSignupForm;
